<app-layout size="100%">
  <app-breadcrumb [breadcrumbItems]="[
  { label: ('breadcrumb.login' | translate), link: '/' },
  { label: ('updateEmail.header' | translate) }
]"></app-breadcrumb>
  <div class="form-section">
    <app-title title="updateEmail.header" />
    <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">

      <app-input [label]="'updateEmail.newEmail' | translate" [formGroup]="emailForm" name="newEmail" type="email"
        [required]="true"></app-input>

      <app-input [label]="'updateEmail.confirmEmail' | translate" [formGroup]="emailForm" name="confirmEmail"
        type="email" [required]="true"></app-input>

      @if (emailMismatch) {
      <div class="error">
        {{ 'updateEmail.emailMismatch' | translate}}
      </div>
      }

      @if (error) {
      <div class="error">
        {{ 'updateEmail.error' | translate}}
        <a routerLink="/" queryParamsHandling="preserve" class="goBack">{{ 'updateEmail.clickHere' |
          translate}}</a>
      </div>
      }

      @if (success) {
      <div class="success">
        {{ 'updateEmail.success' | translate}}
        <a routerLink="/" queryParamsHandling="preserve" class="goBack">{{ 'updateEmail.clickHere' |
          translate}}</a>
      </div>
      }

      <div class="button-group">
        @if (submitting) {
        <app-spinner></app-spinner>
        } @else {
        <app-button variant="primary">
          <button type="submit" data-testid="update-email-submit"
            [disabled]="!emailForm.valid || emailMismatch || button_clicked">{{
            'updateEmail.changeEmailInput' | translate }}</button>
        </app-button>
        }

        <app-button variant="secondary">
          <a routerLink="/continue" queryParamsHandling="preserve" class="btn btn-secondary" type="button">{{
            'updateEmail.cancel' | translate }}</a>
        </app-button>
      </div>
    </form>
  </div>
</app-layout>